import styled from 'styled-components';
import { colors } from "../../../styles/colors";

interface ISelectableButton {
  selected?: boolean;
  disabled?: boolean;
  width?: number;
}

export const Button = styled.button<ISelectableButton>`
  width: ${({ width }) => width ? `${width}px` : 'auto'};
  height: 40px;
  padding: 0 16px;
  border-radius: 1.8rem;
  border: 2px solid ${colors.cyanLightViveo};
  font-size: calc(10.8564px + 0.12vw);
  font-weight: 800;
  user-select: none;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-right: 1rem;

  ${({ selected, disabled }) => {
    if (disabled) {
      return `
        border: 2px solid #BCBCBC;
        background-color: #FFF;
        color: #BCBCBC;
      `;
    }
    if (selected) {
      return `
        background-color: ${colors.cyanLightViveo};
        color: ${colors.greenDarkViveo};;
      `;
    }
    return `
      background-color: #FFF;
      color: ${colors.greenDarkViveo};
    `;
  }}

  &:hover {
    opacity: ${({ disabled }) => !disabled && 0.9};
  }
`;
